import React from "react";
import styled from "styled-components";
import ColorPopup from "../../Shared/ColorPopup";
import MarginBox from "../../Shared/MarginBox";
import SettingsSlider from "../../Shared/SettingsSlider";
import TextView from "../../../TextView";
import CustomSwitch from "../../../CustomSwitch";
import { ASSETS } from "../../../../utils/config";
import Dropdown from "../../../Dropdown";

const Container = styled.div``;

const GridTypeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
`;

const GridTypeItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: ${(props) =>
    props.isSelected ? "2px solid #625B71" : "border: 1px solid  #CAC4D0"};
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0px 0px 9.3px 0px #3b3b3b1c;
  height: 120px;
  &:focus-visible {
    outline: 2px solid #625b71;
    outline-offset: 2px;
  }
`;

const GridTypeImage = styled.img`
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  opacity: ${(props) => (props.isSelected ? 1 : 0.8)};
`;

const GRID_TYPES = {
  STANDARD: "standard",
  QUILTED: "quilted",
  MASONRY: "masonry",
  EVEN: "even",
};

const baseGridTypes = [
  {
    title: GRID_TYPES.STANDARD,
    image: ASSETS.defaultGrid,
  },
  {
    title: GRID_TYPES.QUILTED,
    image: ASSETS.quiltedGrid,
  },
  {
    title: GRID_TYPES.MASONRY,
    image: ASSETS.masonryGrid,
  },
];

// The 4th "Even Grid" tile. Reuses the existing defaultGrid icon (no new asset
// needed). Label override -> "Even Grid".
const gridTypes = [
  ...baseGridTypes,
  {
    title: GRID_TYPES.EVEN,
    label: "Even Grid",
    image: ASSETS.defaultGrid,
  },
];

const columnsArray = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
];
export default function Layout({
  margin,
  isApplyMarginOnAllSides,
  allSideMargin,
  borderRadius,
  borderColor,
  borderWidth,
  dropShadowColor,
  showCaptions,
  gridType,
  handleChange,
  handleAdjustment,
  columns,
}) {
  return (
    <Container>
      <TextView variant="subtitle">Grid Type</TextView>
      <GridTypeContainer>
        {gridTypes.map((type) => {
          const isSelected = gridType === type.title;
          const onSelect = () => handleChange("gridType", type.title);
          return (
          <GridTypeItem
            key={type.title}
            isSelected={isSelected}
            role="radio"
            aria-checked={isSelected}
            aria-label={type.label || type.title}
            tabIndex={0}
            onClick={onSelect}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                if (e.key === " ") e.preventDefault();
                onSelect();
              }
            }}
          >
            <GridTypeImage
              src={type.image}
              alt={type.label || type.title}
              isSelected={isSelected}
            />
            <TextView style={{ textTransform: "capitalize" }}>
              {type.label || type.title}
            </TextView>
          </GridTypeItem>
          );
        })}
      </GridTypeContainer>

      <TextView variant="subtitle" style={{ marginBottom: 10 }}>
        Show Captions
        <CustomSwitch
          checked={showCaptions}
          onChange={() => handleChange("showCaptions")}
        />
      </TextView>
      <Dropdown
        label={"Columns"}
        labelVariant={"subtitle"}
        variant="outlined"
        options={columnsArray}
        value={columns}
        defaultValue={columns}
        onChange={(e) => handleChange("columns", e.target.value)}
        style={{ marginBottom: 20 }}
      />
      <MarginBox
        margin={margin}
        increaseMargin={(side) => handleAdjustment(side, "increase")}
        decreaseMargin={(side) => handleAdjustment(side, "decrease")}
        isApplyMarginOnAllSides={isApplyMarginOnAllSides}
        allSideMargin={allSideMargin}
        handleMarginCheckBox={() => handleChange("marginCheckbox")}
        handleSliderMarginChange={(value) =>
          handleChange("allSideMargin", value)
        }
        handleMarginChange={(side, value) =>
          handleChange("margin", value, side)
        }
        symbol={"px"}
      />
      <SettingsSlider
        title="Corner Rounding"
        sliderValue={borderRadius}
        onValueChange={(val) => handleChange("border", val)}
        min={0}
        max={20}
      />
      <ColorPopup
        title="Border"
        background={borderColor}
        handleChangeBackgroundColor={(val) => handleChange("borderColor", val)}
        resetBackgroundColor={() => handleChange("resetColor")}
        sliderBoxTitle={"Border Width"}
        sliderValue={borderWidth}
        sliderChange={(val) => handleChange("borderWidth", val)}
        sliderMinValue={0}
        sliderMaxValue={8}
        sliderSymbol={"px"}
        isHideGradient={true}
        showSuggestedColorPalette={true}
        isBorderSlider
      />

      <ColorPopup
        title="Drop Shadow"
        background={dropShadowColor}
        handleChangeBackgroundColor={(val) =>
          handleChange("dropShadowColor", val)
        }
        resetBackgroundColor={() => handleChange("resetShadow")}
        showSlider={false}
        isHideGradient={true}
        showSuggestedColorPalette={true}
      />
    </Container>
  );
}
